module.exports = __webpack_public_path__ + "img/10-6.389463d4.png";